(()=>{
  const initialise=()=>{
    const popup=document.querySelector('[data-ra-community]');
    if(!popup||popup.dataset.initialised)return;
    popup.dataset.initialised='true';
    const key='ra-community-seen-v1';
    const designMode=popup.dataset.designMode==='true';
    const once=popup.dataset.sessionOnce==='true';
    let seen=false,timer,observer,focusBefore;
    try{seen=sessionStorage.getItem(key)==='true';}catch{}
    const markSeen=()=>{try{sessionStorage.setItem(key,'true');}catch{}};
    const close=()=>{if(popup.open)popup.close();};
    const open=()=>{
      if(!popup.isConnected||popup.open)return;
      focusBefore=document.activeElement;
      popup.showModal();markSeen();observer?.disconnect();document.removeEventListener('visibilitychange',attempt);
      popup.querySelector('[data-community-close]')?.focus({preventScroll:true});
    };
    const attempt=()=>{
      if(document.visibilityState==='hidden'||document.querySelector('dialog[open]'))return;
      open();
    };
    popup.querySelectorAll('[data-community-close]').forEach(button=>button.addEventListener('click',close));
    popup.addEventListener('click',event=>{
      if(event.target!==popup)return;
      const r=popup.getBoundingClientRect();
      if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close();
    });
    popup.addEventListener('close',()=>{markSeen();if(focusBefore?.isConnected)focusBefore.focus({preventScroll:true});});
    popup.querySelector('[data-community-whatsapp]')?.addEventListener('click',close);
    if(popup.querySelector('[data-community-result]')){open();return;}
    if(designMode){
      document.addEventListener('shopify:section:select',event=>{if(event.target.contains(popup))open();});
      document.addEventListener('shopify:section:deselect',close);
      return;
    }
    if(once&&seen)return;
    timer=setTimeout(()=>{
      observer=new MutationObserver(attempt);
      observer.observe(document.body,{subtree:true,attributes:true,attributeFilter:['open']});
      document.addEventListener('visibilitychange',attempt);
      attempt();
    },Math.max(1,Number(popup.dataset.delay)||5)*1000);
    document.addEventListener('shopify:section:unload',event=>{
      if(event.target.contains(popup)){clearTimeout(timer);observer?.disconnect();document.removeEventListener('visibilitychange',attempt);}
    });
  };
  initialise();
  document.addEventListener('shopify:section:load',initialise);
})();
